/**
 * Footer Component JavaScript
 * Handles viewport-based lazy loading of Google Maps iframe for performance optimization
 */

(function () {
    'use strict';

    function loadMapIframe(iframe) {
        if (!iframe || iframe.dataset.mapLoaded === 'true') {
            return;
        }

        const delayedSrc = iframe.getAttribute('data-delayed-src');
        if (!delayedSrc) {
            return;
        }

        iframe.dataset.mapLoaded = 'true';
        iframe.setAttribute('src', delayedSrc);

        // Add loading indicator while map loads
        iframe.style.backgroundImage = 'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBzdHJva2U9IiM5OTkiPjxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMSAxKSIgc3Ryb2tlLXdpZHRoPSIyIj48Y2lyY2xlIGN4PSIyMiIgY3k9IjIyIiByPSI2Ij48YW5pbWF0ZSBhdHRyaWJ1dGVOYW1lPSJyIiBiZWdpbj0iMXMiIGR1cj0iM3MiIHZhbHVlcz0iNjsyMjsyMjs2IiBjYWxjTW9kZT0ibGluZWFyIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIvPjxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9InN0cm9rZS1vcGFjaXR5IiBiZWdpbj0iMXMiIGR1cj0iM3MiIHZhbHVlcz0iMTswOzA7MSIgY2FsY01vZGU9ImxpbmVhciIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiLz48L2NpcmNsZT48Y2lyY2xlIGN4PSIyMiIgY3k9IjIyIiByPSI2Ij48YW5pbWF0ZSBhdHRyaWJ1dGVOYW1lPSJyIiBiZWdpbj0iMnMiIGR1cj0iM3MiIHZhbHVlcz0iNjsyMjsyMjsxIiBjYWxjTW9kZT0ibGluZWFyIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIvPjxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9InN0cm9rZS1vcGFjaXR5IiBiZWdpbj0iMnMiIGR1cj0iM3MiIHZhbHVlcz0iMTswOzA7MSIgY2FsY01vZGU9ImxpbmVhciIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiLz48L2NpcmNsZT48Y2lyY2xlIGN4PSIyMiIgY3k9IjIyIiByPSI4Ij48YW5pbWF0ZSBhdHRyaWJ1dGVOYW1lPSJyIiBiZWdpbj0iM3MiIGR1cj0iM3MiIHZhbHVlcz0iNjsxOzE7NiIgY2FsY01vZGU9ImxpbmVhciIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiLz48YW5pbWF0ZSBhdHRyaWJ1dGVOYW1lPSJzdHJva2Utb3BhY2l0eSIgYmVnaW49IjNzIiBkdXI9IjNzIiB2YWx1ZXM9IjE7MDswOzEiIGNhbGNNb2RlPSJsaW5lYXIiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIi8+PC9jaXJjbGU+PC9nPjwvZz48L3N2Zz4=")';
        iframe.style.backgroundRepeat = 'no-repeat';
        iframe.style.backgroundPosition = 'center';
        iframe.style.backgroundSize = '40px 40px';

        // Remove loading indicator once map loads
        iframe.addEventListener(
            'load',
            function () {
                iframe.style.backgroundImage = 'none';
            },
            { once: true }
        );
    }

    /**
     * Initialize delayed loading of Google Maps iframe.
     * It loads once the map area approaches the viewport.
     */
    function initDelayedMapsLoading() {
        const mapIframes = document.querySelectorAll('.footer-google-map-iframe');
        if (!mapIframes.length) {
            return;
        }

        if ('IntersectionObserver' in window) {
            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            loadMapIframe(entry.target);
                            observer.unobserve(entry.target);
                        }
                    });
                },
                {
                    rootMargin: '300px 0px',
                }
            );

            mapIframes.forEach((iframe) => {
                observer.observe(iframe);
            });
            return;
        }

        // Fallback for very old browsers
        window.addEventListener(
            'load',
            function () {
                mapIframes.forEach(loadMapIframe);
            },
            { once: true }
        );
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initDelayedMapsLoading);
    } else {
        initDelayedMapsLoading();
    }

})();
